import React, { Component } from "react";
import { connect } from "react-redux";
import {
  WithStyles,
  withStyles,
  Button,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  Radio,
  createStyles,
  Theme,
  Menu,
  MenuItem,
  Link,
  ClickAwayListener,
  RadioGroup,
} from "@material-ui/core";
import { Error } from "@material-ui/icons";
import { contentManagementService } from "../service";
import { MyPATDialog, MyPATIconButton, MyPATSelect } from "../../common";

import { bindActionCreators } from "redux";
import * as XLSX from "xlsx";

import courseManagementService from "../service/courseManagementServices";
import * as courseManagementActions from "../actions/courseManagementActions";
import cx from "classnames";
import moment from "moment";

import _ from "lodash";
import { CloseOutlined as CloseIcon } from "@material-ui/icons";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { getActiveGoals } from "../actions/courseManagementActions";
import { Goal } from "../types/interfaces/Goal";
import { showMsg } from '../../course/actions/loaderAlert';
import { ExistingScheduledTest } from "../types/interfaces/ExistingScheduledTest";
import { createErrorSheet } from "../helpers/helpers";
import AddConceptOrChapter from "../../mylibrary/components/ContentCreate/AddConceptOrChapter";
import { deleteIcon } from "./treeComponents/component/phaseStyles";

export const styles = (theme: Theme) =>
  createStyles({
    menuItem: {
      borderStyle: "solid",
      borderBottomWidth: 1,
      borderColor: theme.palette.grey[300],
      padding: 0,
      height: "auto",
      minWidth: "170px",
      "&:last-child": {
        borderBottomWidth: 0,
      },
      "& a": {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingRight: theme.spacing.unit * 2,
        paddingLeft: theme.spacing.unit * 2,
        width: "100%",
      },
      "& img, & p": {
        display: "inline-block",
        verticalAlign: "middle",
        fontSize: 14,
        lineHeight: "19px",
        color: "#333333",
      },
    },
    bulkTitle: {
      fontSize: 20,
      fontWeight: 600,
      margin: 0,
    },
    orDevider: {
      position: "relative",
      marginBottom: 50,
      alignItems: "center",
      marginTop: 10,
      "&::before": {
        top: "50%",
        left: "47%",
        content: '"OR"',
        position: "absolute",
        width: "30px",
        height: "30px",
        backgroundColor: "#e5edf5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
        transform: "translate(0%, -50%)",
        borderRadius: "50%",
        fontWeight: 600,
        fontSize: 12,
        color: "#666",
      },
      "&::after": {
        left: "50%",
        content: '" "',
        position: "absolute",
        border: "1px solid #e4e4e4",
        height: "100%",
      },
      "& button": {
        margin: "10px 0",
      },
    },
    paddingLeft: {
      paddingLeft: 40,
    },

    paddingRight: {
      paddingRight: 40,
    },
    disabled: {
      opacity: 0.5,
      cursor: "default",
      pointerEvents: "none",
    },
    optionContainer: {
      marginTop: 10,
      position: "relative",
      "& input": {
        border: "1px solid #DFDFDF",
        width: "100%",
        padding: "10px",
        borderRadius: 4,
        background: "none",
        height: 45,
        lineHeight: "45px",
        cursor: "pointer",
        paddingRight: 70,
        textOverflow: "ellipsis",
        fontSize: 14,
        "&:focus-visible": {
          outline: "2px solid #1d7dea",
        },
      },
    },
    optionlistContainer: {
      position: "relative",
      "&:hover": {
        cursor: "pointer",
      },
      "&::after": {
        top: "5px",
        right: "18px",
        border: "solid rgb(0 0 0 / 0%)",
        height: 0,
        content: '" "',
        zIndex: 999,
        position: "absolute",
        transform: "rotate(226deg)",
        boxShadow: "1px 1px 1px #DFDFDF",
        background: "rgb(255 255 255)",
        borderColor: "rgb(194 225 245 / 0%)",
        borderWidth: 9,
        borderBottomColor: "rgb(255 255 255)",
      },
    },
    optionList: {
      width: "100%",
      border: "1px solid #DFDFDF",
      display: "block",
      position: "absolute",
      backgroundColor: "#fff",
      top: "13px",
      borderRadius: "7px",
      maxHeight: 250,
      overflowX: "hidden",
      overflowY: "auto",
      zIndex: 2,
      "& input": {
        marginTop: 15,
        paddingLeft: 40,
      },
      "& span": {
        display: "block",
        padding: "1px 0px 2px 10px",
        cursor: "pointer",
      },
    },
    optionListEdit: {
      "& span": {
        padding: "10px 15px",
        borderBottom: "1px solid #eee",
      },
    },
    searchContainer: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: "#fff",
      paddingBottom: 15,
      borderBottom: "1px solid #e6e6e6",
      marginBottom: 10,
      paddingLeft: 15,
      paddingRight: 15,
      "& img": {
        left: 29,
        position: "absolute",
        top: 29,
      },
    },
    parentSearchContainer: {
      position: "relative",
      backgroundColor: "#fff",
      marginTop: 10,
      "& input": {
        width: "100%",
        background: "none",
        padding: "20px 20px 20px 15px",
        height: 40,
        lineHeight: 40,
        border: "1px solid #DFDFDF",
        borderRadius: 4,
        "&:focus-visible": {
          outline: "2px solid #1d7dea",
        },
      },
      "& img": {
        right: 15,
        position: "absolute",
        top: 12,
      },
    },
    padding2x: {
      //   padding: "10px 0",
    },
    courseTitle: {
      fontSize: 16,
      fontWeight: 600,
      color: "#666",
      padding: "10px 0 0 0",
    },
    plusCourse: {
      position: "relative",
      "& span": {
        position: "absolute",
        right: 0,
        top: 8,
        color: "#1d7dea",
        width: 30,
        height: 30,
        backgroundColor: "#e8f2fd",
        borderRadius: "50%",
        fontSize: 13,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
        marginRight: 40,
      },
    },
    fileInfo: {
      fontSize: 12,
      lineHeight: "16px",
      color: "#999",
      display: "block",
      fontWeight: "normal",
    },
    uploadPreview: {
      "&>:first-child": {
        justifyContent: "center",
        "&>:first-child": {
          "&>:first-child": {
            margin: "16px 0",
          },
        },
      },
    },
    textCenter: {
      textAlign: "center",
    },
    noBorder: {
      borderBottom: 0,
    },
    iconRoot: {
      fill: theme.palette.text.secondary,
      // opacity: 0.5,
      margin: 0,
      width: "2rem",
      height: "2rem",
    },
    buttonCloseCont: {
      position: "relative",
      height: 20,
      "& button": {
        position: "absolute",
        right: "-15px",
        top: "-35px",
        border: "none",
      },
    },
    arrowIcon: {
      position: "absolute",
      right: 10,
      top: 12,
      transform: "scale(1.3)",
      zIndex: 1,
      width: 20,
      height: 20,
      backgroundColor: "#fff",
      cursor: "pointer",
      "& img": {
        // opacity: 0.3,
        width: 15,
      },
    },
    testRadioGroup: {
      width: "100%",
      display: "inline-block",
      textAlign: "center",
      "& $label": {
        "&>:nth-child(2)": {
          fontSize: 16,
          fontWeight: 400,
          color: "#333",
        },
      },
    },
    customSelect: {
      marginBottom: 10,
      "&>div:nth-of-type(1)": {
        width: "100%",
        marginTop: 10,
        "& select": {
          height: 44,
          fontSize: "14px",
        },
      },
    },
    errorText: {
      color: "#F21D1D",
      verticalAlign: "middle",
      marginTop: "3px",
      "& svg": {
        verticalAlign: "bottom",
      },
    },
    mapDialog: {
      marginTop: "-15px",
    },
    greyBackground: {
      backgroundColor: "#ccc",
    },
    containerBox: {
      border: "1px solid #E4E4E4;",
      borderRadius: "5px",
      backgroundColor: "#FFFFFF",
    },
    upperContainer: {
      width: "100%",
      "&>div:nth-of-type(1)": {
        borderBottom: "1px solid #D9D9D9;",
        fontSize: "20px",
        paddingBottom: "18px",
      },
    },
    layerContainer: {
      padding: "30px 23px",
      width: "100%",
      borderBottom: "1px solid #D9D9D9;",
    },
    lowerContainer: {
      padding: "25px 28px 10px 28px",
      width: "100%",
    },
    displayIndex: {
      fontSize: "20px",
      fontWeight: 600,
    },
    addSyllabus: {
      fontWeight: 600,
      fontSize: "16px",
      padding: "12px 0",
      marginBottom: "24px",
      borderBottom: "1px solid #D9D9D9",
    },
    bottomContainer: {
      borderTop: "1px solid #E6E6E6",
      width: "100%",
      textAlign: "center",
      padding: "15px 0",
      marginTop: "12px",
      "& button": {
        backgroundColor: "#1D7DEA",
        color: "#FFFFFF",
      },
    },
    header: {
      fontSize: "36px",
      fontWeight: 600,
      marginBottom: "23px",
      "& span": {
        paddingLeft: "15px",
      },
      "& img": {
        cursor: "pointer",
      },
    },
    addMoreSyllabus: {
      display: "block",
      color: "#1D7DEA",
      textAlign: "end",
      marginTop: "24px",
      "& span": {
        cursor: "pointer",
        "& img": {
          height: "14px",
          padding: "2px 8px 0 0",
        },
      },
    },
    deleteItem: {
      marginLeft: "auto",
      marginBlock: "auto",
    },
    questionActionBtn: {
      padding: 10,
      minWidth: "auto",
      border: "1px solid #DFDFDF",
      color: theme.palette.text.secondary,
      borderRadius: 4,
    },
    separation: {
      padding: "15px",
      borderBottom: "1px solid #D9D9D9",
    },
    selectGoal: {
      width: "50%",
    },
    confirmPopup: {
      textAlign: "center",
      "& h4": {
        fontSize: "16px",
        fontWeight: 400,
        marginTop: "36px",
        marginBottom: "24px",
      },
      "& button": {
        marginBottom: "40px",
        padding: "20px 40px",
      },
    },
    closePosition: {
      display: "inline-block",
      position: "absolute",
      top: "8px",
      right: "8px",
    },
    progressPopup: {
      maxWidth: '360px',
      '&>div>div': {
        minWidth: '100%',
      }
    },
    progressSection: {
      padding: '0 20px 25px',
      '& h1': {
        fontSize: 25,
        fontWeight: 600,
        color: '#333333',
        textAlign: 'center',
        margin: '0 0 20px',
      },
      '& span': {
        fontSize: 22,
        fontWeight: 500,
        color: '#333',
        display: 'inline-block', 
      },
      '& .strong': {
        fontWeight: 600,
      },
      '& .textCenter': {
        textAlign: 'center',
      }
    },
    customDisable: {
      opacity: 0.6,
      pointerEvents: "none",
    },
  });

enum mappingType {
  mapped = "mapped",
  unmapped = "unmapped",
}

interface SyllabusMapping {
  // scheduleIds: any[],
  subjects: any[];
  selectedTest: any[];
  filteredTestList: ExistingScheduledTest[];
  showTestDropdown: boolean;
}

interface AddSyllabusProps extends WithStyles<typeof styles> {
  classes: any;
  courseList: any[];
  getCourseList: Function;
  setBulkImportTest: Function;
  fetchExistingScheduledTests: Function;
  openMapScheduled: boolean;
  closeBulkImport: Function;
  redirectToBulkImport: Function;
  getActiveGoals: Function;
  goals: Goal[];
  fetchScheduleTests: Function;
  scheduledTests: ExistingScheduledTest[];
  history: any;
  showMsg: any;
}

interface AddSyllabusState {
  openConfirmationPopup: boolean;
  openProgressPopup: boolean,
  updateTestsCount: Number,
  totalTestsCount: Number,
  mappingType: mappingType;
  filteredGoals: Goal[];
  showSingleGoalDropdown: boolean;
  selectedGoal: Goal | { [name: string]: string };
  isLoading: boolean;
  showTestDropdown: boolean;
  selectedTest: string[];
  filteredTestList: ExistingScheduledTest[];
  primaryTest: ExistingScheduledTest | undefined;
  disabledPrimaryDropDown: boolean;
  testCourseCount: number;
  scheduleIds: string[];
  inputTestId: string;
  formErrors: any;
  openDialog: boolean;
  hoverGoalId: string;
  syllabusMappingArr: SyllabusMapping[];
  // subjects: any[];
}

class AddSyllabus extends Component<AddSyllabusProps, AddSyllabusState> {
  constructor(props: AddSyllabusProps) {
    super(props);
    this.state = {
      openConfirmationPopup: false,
      openProgressPopup: false,
      updateTestsCount: 0,
      totalTestsCount: 0,
      openDialog: false,
      mappingType: mappingType.unmapped,
      filteredGoals: [],
      showSingleGoalDropdown: false,
      selectedGoal: { name: "" },
      isLoading: false,
      showTestDropdown: false,
      filteredTestList: [],
      selectedTest: [],
      primaryTest: undefined,
      disabledPrimaryDropDown: false,
      testCourseCount: 0,
      scheduleIds: [],
      inputTestId: "",
      formErrors: {},
      hoverGoalId: "",
      syllabusMappingArr: [
        {
          subjects: [],
          selectedTest: [],
          filteredTestList: [],
          showTestDropdown: false,
        },
      ],
    };
    this.getFilteredGoals = _.debounce(this.getFilteredGoals, 200);
    this.getTestSuggestions = _.debounce(this.getTestSuggestions, 200);
    this.toggleGoalDropDown = _.debounce(this.toggleGoalDropDown, 100);
    this.toggleTestDropdown = _.debounce(this.toggleTestDropdown, 100);
    this.handleTestID = _.debounce(this.handleTestID, 200);
  }
  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.openMapScheduled != prevState.openDialog) {
      return {
        openDialog: nextProps.openMapScheduled,
      };
    } else return null;
  }
  componentDidMount() {
    if (!this.props.goals.length) {
      this.props.getActiveGoals();
    }
  }
  componentDidUpdate(prevProps: AddSyllabusProps, prevState: AddSyllabusState) {
    if (
      this.state.selectedGoal !== prevState.selectedGoal &&
      !_.isEmpty(this.state.selectedGoal._id)
    ) {
      this.getScheduledTests();
    }
  }

  toggleGoalDropDown = () => {
    const { showSingleGoalDropdown } = this.state;
    const { goals } = this.props;

    this.setState({
      showSingleGoalDropdown: !showSingleGoalDropdown,
      filteredGoals: [...goals],
    });
  };

  getAllSelectedTests = () => {
    const selTests = new Set();
    this.state.syllabusMappingArr.forEach((arr) => {
      arr.selectedTest.forEach((test) => {
        selTests.add(test);
      });
    });

    return selTests;
  };

  toggleTestDropdown = (index: number) => {
    const [...arr] = this.state.syllabusMappingArr;
    const { scheduledTests } = this.props;

    if (arr[index]) {
      const allSelectedTests = this.getAllSelectedTests();
      let filteredTestList: ExistingScheduledTest[] = [];
      const availableTestsList = scheduledTests.filter(
        (tests) => !allSelectedTests.has(tests._id)
      );
      this.state.syllabusMappingArr[index].selectedTest.forEach((tests) => {
        const matchedSelectedTest = scheduledTests.find(
          (scTests) => scTests._id === tests
        );
        matchedSelectedTest && filteredTestList.push(matchedSelectedTest);
      });
      filteredTestList = [...filteredTestList, ...availableTestsList];

      arr[index].showTestDropdown = !arr[index].showTestDropdown;
      arr[index].filteredTestList = [...scheduledTests];

      this.setState({
        syllabusMappingArr: arr,
        filteredTestList,
      });
    }
  };
  getFilteredGoals(value: string) {
    const { goals } = this.props;
    const { isLoading } = this.state;
    this.setState({ isLoading: true });
    this.setState((prevState) => {
      let suggestions: any = [];
      value = value.toString();
      value = value.replace(/[{()}]/g, "");
      value = value.replace(/\\|\//g, "");

      if (value.length > 0) {
        value = value.toLowerCase();
        for (let indx = 0; indx < goals.length; indx++) {
          let ug = goals[indx];
          if (
            ug.name &&
            ug.name
              .replace(/[{()}]/g, "")
              .replace(/\\|\//g, "")
              .toLocaleLowerCase()
              .search(value) != -1
          ) {
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...goals];
      }
      return { filteredGoals: suggestions, isLoading: false };
    });
  }
  getTestSuggestions(value: string, index: number) {
    let { scheduledTests } = this.props;

    const allSelectedTests = this.getAllSelectedTests();
    let filteredTestList: ExistingScheduledTest[] = [];
    const availableTestsList = scheduledTests.filter(
      (tests) => !allSelectedTests.has(tests._id)
    );
    this.state.syllabusMappingArr[index].selectedTest.forEach((tests) => {
      const matchedSelectedTest = scheduledTests.find(
        (scTests) => scTests._id === tests
      );
      matchedSelectedTest && filteredTestList.push(matchedSelectedTest);
    });
    scheduledTests = [...filteredTestList, ...availableTestsList];

    value = value.toString();
    value = value.replace(/[{()}]/g, "");
    value = value.replace(/\\|\//g, "");

    this.setState((prevState) => {
      let suggestions: any = [];
      if (value.length > 0) {
        value = value.toLowerCase();

        for (let indx = 0; indx < scheduledTests.length; indx++) {
          let ug = scheduledTests[indx];
          if (
            ug.displayName &&
            ug.displayName
              .replace(/[{()}]/g, "")
              .replace(/\\|\//g, "")
              .toLocaleLowerCase()
              .search(value) != -1
          ) {
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...scheduledTests];
      }
      const copyObj = JSON.parse(JSON.stringify(this.state.syllabusMappingArr));

      copyObj[index].filteredTestList = suggestions;
      return { syllabusMappingArr: copyObj, filteredTestList: suggestions };
    });
  }
  getScheduledTests() {
    const { selectedGoal } = this.state;
    this.setState({
      selectedTest: [],
      filteredTestList: [],
      primaryTest: undefined,
    });
    const params = {
      itemType: "scheduledTests",
      id: selectedGoal._id,
    };
    const queryParams = {
      mappingType: this.state.mappingType,
    };
    this.props.fetchScheduleTests({ params, queryParams });
  }

  generatePayload = () => {
    let copyObj = JSON.parse(JSON.stringify(this.state.syllabusMappingArr));

    copyObj = copyObj.filter(
      (syllabus: SyllabusMapping) =>
        syllabus.selectedTest.length && syllabus.subjects.length
    );

    copyObj.forEach((mapping: any, index: number) => {
      const scheduleIds: string[] = [];
      mapping.selectedTest.forEach((test: string) => {
        const scheduleId = this.props.scheduledTests.find(
          (scTests) => scTests._id === test
        );
        if (scheduleId) {
          scheduleIds.push(scheduleId.scheduleID);
        }
      });
      mapping.scheduleIds = [...scheduleIds];
    });
    return copyObj;
  };

  mapTestsSyllabus = async () => {
    const syllabus = this.generatePayload();
    const LIMIT = 10;
    let totalTestToUpdateCount = 0;
    syllabus.forEach((currentSyllabus: any) => {
      const currentTestsCount = currentSyllabus.scheduleIds.length;
      totalTestToUpdateCount += currentTestsCount;
    })
    this.setState({
      openConfirmationPopup: false,
      openProgressPopup: true,
      totalTestsCount: totalTestToUpdateCount
    });
    let testsUpdate = 0;
    for (const currentSyllabus of syllabus) {
      const totalScheduleIds = currentSyllabus.scheduleIds.length;
      const scheduleIds = currentSyllabus.scheduleIds;
      for (let i = 0; i < totalScheduleIds; i += LIMIT) {
        const currentScheduleIds = scheduleIds.slice(i, i + LIMIT);
        const currentScheduleIdsCount = currentScheduleIds.length;
        testsUpdate += currentScheduleIdsCount;
        currentSyllabus.scheduleIds = currentScheduleIds;
        await contentManagementService.mapBulkSyllabus({ syllabus: [currentSyllabus] });
        this.setState(({ updateTestsCount: testsUpdate }));
      }
    };
    this.setState({ selectedGoal: { name: '' }, openProgressPopup: false });
    this.reinitializeMappings();
    this.props.showMsg('Successfully updated syllabus in given schedule Id(s)', 'success');
  };

  testRenderer = (index: number) => {
    const { selectedTest } = this.state.syllabusMappingArr[index];
    const { scheduledTests } = this.props;
    if (scheduledTests && scheduledTests.length > 0) {
      return (
        scheduledTests &&
        scheduledTests
          .reduce((acc: string[], curr) => {
            if (selectedTest.includes(curr._id)) {
              acc.push(curr.displayName);
            }
            return acc;
          }, [])
          .splice(0, 5)
          .join(", ")
      );
    }
    return [];
  };

  handleTestChange = (event: any, index: number) => {
    let eventId = event.target.value;
    let isChecked = event.target.checked;
    let { filteredTestList } = this.state;
    const { selectedTest } = this.state.syllabusMappingArr[index];
    let newSelectedSubjects = [...selectedTest];

    if (isChecked) {
      if (eventId === "SelectAll") {
        newSelectedSubjects = [];
        filteredTestList.forEach((sub) => {
          newSelectedSubjects.push(sub._id);
        });
      } else {
        newSelectedSubjects.push(eventId);
      }
    } else {
      if (eventId === "SelectAll") {
        newSelectedSubjects = [];
      } else {
        let indx = newSelectedSubjects.indexOf(eventId);
        newSelectedSubjects.splice(indx, 1);
      }
    }

    const copyArr = JSON.parse(JSON.stringify(this.state.syllabusMappingArr));
    copyArr[index].selectedTest = newSelectedSubjects;

    this.setState({ syllabusMappingArr: copyArr });
  };

  addMoreSyllabusHandler = () => {
    const [...arr] = this.state.syllabusMappingArr;
    arr.push({
      subjects: [],
      selectedTest: [],
      showTestDropdown: false,
      filteredTestList: [],
    });
    this.setState({ syllabusMappingArr: arr });
  };

  handleTestID = async (contentID: string) => {
    const { selectedGoal, formErrors } = this.state;
    const res = await courseManagementService.validateMapTestId({
      testContentId: contentID,
      courseId: selectedGoal._id,
    });
    const { test, error } = res;
    const newFormErrors = { ...formErrors };
    if (error) {
      newFormErrors["testId"] = error;
    } else {
      delete newFormErrors["testId"];
    }
    this.setState({
      inputTestId: contentID,
      primaryTest: test,
      formErrors: newFormErrors,
      disabledPrimaryDropDown: !_.isEmpty(test),
    });
  };

  handlePopupClose = () => {
    this.setState({ openConfirmationPopup: false });
  };

  handleChange = (event: any) => {
    const { name, value } = event.target;
    const { filteredTestList } = this.state;
    if (name === "testId") {
      const trimmedValue = value.trim();
      this.setState({ inputTestId: trimmedValue });
      if (trimmedValue.length > 3) {
        this.handleTestID(trimmedValue);
      }
    } else if (name === "primaryTest") {
      const primaryTest = filteredTestList.find((t) => t._id === value);
      this.setState({ primaryTest });
    }
  };

  handleMouseHover = (goalId: string) => {
    this.setState({
      hoverGoalId: goalId,
    });
  };

  goback = () => {
    this.props.history.goBack();
  };

  deleteConceptmapping = (index: number) => {
    const arr = JSON.parse(JSON.stringify(this.state.syllabusMappingArr));

    arr.splice(index, 1);
    this.setState({ syllabusMappingArr: arr });
  };

  handleAddConceptChapterFormChange = (key: any, index: number) => (
    updateFormData: any
  ) => {
    updateFormData.forEach((element: { chapters: any; subSubjects: { chapters: any; }[]; }) => {
      element.chapters = []//element.subSubjects[0].chapters;
      element.subSubjects.forEach((subSubject) => {
        element.chapters = [...element.chapters, ...subSubject.chapters]
      })
    });
    const copyArr = JSON.parse(JSON.stringify(this.state.syllabusMappingArr));
    copyArr[index].subjects = updateFormData;
    this.setState({ syllabusMappingArr: copyArr });
  };

  showConfirmationPopup = () => {
    this.setState({ openConfirmationPopup: true });
  };

  reinitializeMappings = () => {
    this.setState({
      syllabusMappingArr: [
        {
          subjects: [],
          selectedTest: [],
          filteredTestList: [],
          showTestDropdown: false,
        },
      ],
    });
  };

  render() {
    const { classes, goals } = this.props;
    const {
      showSingleGoalDropdown,
      filteredGoals,
      selectedGoal,
      isLoading,
      filteredTestList,
      mappingType,
      hoverGoalId,
    } = this.state;
    let totalTests = 0;
    this.state.syllabusMappingArr.forEach((elem) => {
      totalTests += elem.selectedTest.length;
    });
    return (
      <>
        <div className={classes.header}>
          <img src="/assets/svg/left-arrow.svg" onClick={this.goback} />
          <span>Courses</span>
        </div>
        <Grid container className={classes.containerBox}>
          <div className={classes.layerContainer}>
            <div className={classes.upperContainer}>
              <div>Add Syllabus For Scheduled Tests</div>
              <Grid item xs={12} className={classes.selectGoal}>
                <Typography variant="h4" className={classes.courseTitle}>
                  Select Goal
                </Typography>
                <div className={classes.optionContainer}>
                  <div onClick={this.toggleGoalDropDown}>
                    <input
                      type="text"
                      placeholder="Select A Goal"
                      value={selectedGoal.name}
                    />
                    <Grid className={classes.arrowIcon}>
                      <img src="/assets/svg/dropdown-arrow.svg" />
                    </Grid>
                  </div>
                  {showSingleGoalDropdown && (
                    <ClickAwayListener onClickAway={this.toggleGoalDropDown}>
                      <div className={classes.optionlistContainer}>
                        <div
                          className={[
                            classes.optionList,
                            classes.optionListEdit,
                          ].join(" ")}
                        >
                          <div className={classes.searchContainer}>
                            <input
                              type="text"
                              placeholder="Search Goal Name"
                              onChange={(event) => {
                                this.getFilteredGoals(event.target.value);
                              }}
                            />
                            <img src="/assets/svg/userManagement/search-icon.svg" />
                          </div>
                          {filteredGoals.length === 0 && !isLoading && (
                            <span>No Goal found</span>
                          )}
                          {isLoading ? (
                            <span>Loading...</span>
                          ) : (
                            (filteredGoals || []).map((goal) => (
                              <span
                                className={
                                  selectedGoal._id === goal._id ||
                                  hoverGoalId === goal._id
                                    ? classes.greyBackground
                                    : ""
                                }
                                key={goal._id}
                                onClick={() =>
                                  this.setState(
                                    {
                                      selectedGoal: goal,
                                      showSingleGoalDropdown: false,
                                      hoverGoalId: "",
                                    },
                                    () => {
                                      this.reinitializeMappings();
                                    }
                                  )
                                }
                                onMouseOver={() =>
                                  this.handleMouseHover(goal._id)
                                }
                              >
                                {goal.name}
                              </span>
                            ))
                          )}
                        </div>
                      </div>
                    </ClickAwayListener>
                  )}
                </div>
              </Grid>
            </div>
          </div>

          {this.state.syllabusMappingArr.map((d, index) => {
            const displayIndex = `#${index + 1} Syllabus Update`;
            return (
              <>
                <div className={classes.lowerContainer}>
                  <Grid item xs={12} className={classes.padding2x}>
                    <Grid container>
                      <Grid item>
                        <div className={classes.displayIndex}>
                          {displayIndex}
                          <Typography
                            variant="h4"
                            className={classes.courseTitle}
                          >
                            Select Scheduled Tests
                          </Typography>
                        </div>
                      </Grid>
                      {!(
                        index === 0 &&
                        this.state.syllabusMappingArr.length === 1
                      ) && (
                        <Grid item className={classes.deleteItem}>
                          <Button
                            variant="text"
                            className={
                              classes.questionActionBtn + "  btn-delete "
                            }
                            onClick={() => this.deleteConceptmapping(index)}
                          >
                            <img src="/assets/svg/myLibrary/delete-outline.svg" />
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                    <div className={classes.optionContainer}>
                      <div
                        className={cx(
                          classes.plusCourse,
                          !selectedGoal.name ? classes.disabled : ""
                        )}
                        onClick={() => this.toggleTestDropdown(index)}
                      >
                        <input
                          type="text"
                          placeholder="Select Scheduled Tests"
                          value={this.testRenderer(index)}
                        />
                        {this.state.syllabusMappingArr[index].selectedTest
                          .length > 5 && (
                          <span>
                            +
                            {this.state.syllabusMappingArr[index].selectedTest
                              .length - 5}
                          </span>
                        )}
                        <Grid className={classes.arrowIcon}>
                          <img src="/assets/svg/dropdown-arrow.svg" />
                        </Grid>
                      </div>

                      {this.state.syllabusMappingArr[index]
                        .showTestDropdown && (
                        <ClickAwayListener
                          onClickAway={() => this.toggleTestDropdown(index)}
                        >
                          <div className={classes.optionlistContainer}>
                            <div className={classes.optionList}>
                              <div className={classes.searchContainer}>
                                <input
                                  type="text"
                                  placeholder="Search Test Name"
                                  onChange={(event) => {
                                    this.getTestSuggestions(
                                      event.target.value,
                                      index
                                    );
                                  }}
                                />
                                <img src="/assets/svg/userManagement/search-icon.svg" />
                              </div>
                              {filteredTestList.length === 0 && (
                                <span>No Tests found</span>
                              )}
                              {filteredTestList.length > 0 && (
                                <span>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          filteredTestList.length ==
                                          this.state.syllabusMappingArr[index]
                                            .selectedTest.length
                                        }
                                        onChange={() =>
                                          this.handleTestChange(event, index)
                                        }
                                        name="Select All"
                                        color="primary"
                                      />
                                    }
                                    label="Select All"
                                    value="SelectAll"
                                    key="select_all_test"
                                  />
                                </span>
                              )}
                              {(filteredTestList || []).map(
                                ({
                                  _id,
                                  displayName,
                                  scheduleID,
                                  testType,
                                  paperDetail,
                                }) => (
                                  <span>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={this.state.syllabusMappingArr[
                                            index
                                          ].selectedTest.includes(_id)}
                                          onChange={() =>
                                            this.handleTestChange(event, index)
                                          }
                                          name="checkedB"
                                          color="primary"
                                        />
                                      }
                                      label={`${displayName} | ${_.capitalize(
                                        testType ? testType : paperDetail.type
                                      )} | ${
                                        paperDetail.contentId &&
                                        mappingType === "mapped"
                                          ? paperDetail.contentId
                                          : "Schedule ID: " + scheduleID
                                      }`}
                                      key={_id}
                                      value={_id}
                                    />
                                  </span>
                                )
                              )}
                            </div>
                          </div>
                        </ClickAwayListener>
                      )}
                    </div>
                  </Grid>
                  <div className={classes.addSyllabus}>
                    <span>Add Syllabus</span>
                  </div>
                  <AddConceptOrChapter
                    reInitialiseValues
                    showWithoutExpansionPanel={true}
                    customDisabled={
                      !(
                        this.state.selectedGoal &&
                        this.state.syllabusMappingArr[index].selectedTest.length
                      )
                    }
                    formData={
                      _.isUndefined(
                        this.state.syllabusMappingArr[index].subjects
                      )
                        ? []
                        : JSON.parse(
                            JSON.stringify(
                              this.state.syllabusMappingArr[index].subjects
                            )
                          )
                    }
                    handleFormChange={this.handleAddConceptChapterFormChange(
                      "primary",
                      index
                    )}
                  />
                  {index === this.state.syllabusMappingArr.length - 1 ? (
                    <a
                      className={[
                        classes.addMoreSyllabus,
                        !(
                          this.state.syllabusMappingArr[
                            this.state.syllabusMappingArr.length - 1
                          ].selectedTest.length && this.state.selectedGoal
                        )
                          ? classes.customDisable
                          : "",
                      ].join(" ")}
                    >
                      <span onClick={this.addMoreSyllabusHandler}>
                        <img src="/assets/svg/addIcon.svg" alt="plus" />
                        Continue Adding Syllabus for Scheduled Tests
                      </span>
                    </a>
                  ) : (
                    <div className={classes.separation} />
                  )}
                </div>
              </>
            );
          })}
          <div className={classes.bottomContainer}>
            <Button
              onClick={this.showConfirmationPopup}
              className={
                !(
                  this.state.syllabusMappingArr[
                    this.state.syllabusMappingArr.length - 1
                  ].selectedTest.length && this.state.selectedGoal
                )
                  ? classes.customDisable
                  : ""
              }
            >
              Update Syllabus
            </Button>
          </div>
        </Grid>

        {/* Confirmation popup */}
        <MyPATDialog
          dialogOpen={this.state.openConfirmationPopup}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: "sm",
          }}
          isPerfectScrollbar={false}
          isAlignCenter={true}
        >
          <div className={classes.closePosition}>
            <MyPATIconButton
              buttonVariant={"withoutBorderCloseIcon"}
              onClick={this.handlePopupClose}
            >
              <CloseIcon classes={{ root: classes.iconRoot }} />
            </MyPATIconButton>
          </div>
          <Typography variant="body1" className={classes.confirmPopup}>
            <img src="/assets/svg/map-scheduled-icon.svg" alt="Confirm Icon" />
            <h3>Scheduled Tests Syllabus</h3>
            <h4>
              Are you sure you want to add syllabus for {totalTests} Scheduled
              Test{totalTests === 1 ? "" : "s"}?
            </h4>
            <Button color="primary" onClick={this.handlePopupClose}>
              No
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.mapTestsSyllabus}
            >
              Yes
            </Button>
          </Typography>
        </MyPATDialog>
        <MyPATDialog
          classes={{root:classes.progressPopup}}
          dialogOpen={this.state.openProgressPopup}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: "sm",
          }}
          isPerfectScrollbar={false}
          isAlignCenter={true}
        >
          <div className={classes.closePosition}>
          </div>     
          <div className={classes.progressSection}>
            <h1>Syllabus update in progress</h1> 
            <div className={classes.textCenter}>
              <span>{this.state.updateTestsCount}</span>
              <span> / </span>
              <span className={classes.strong}>{this.state.totalTestsCount} </span>
              <span> &nbsp;  Tests Syllabus Completed</span>  
            </div> 
          </div>       
              
        </MyPATDialog>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  courseList: state.clientManagement.usersManagement.courseList,
  goals: state.courseMangementData.courseManagementReducer.activeGoals,
  scheduledTests:
    state.courseMangementData.courseManagementReducer.scheduledTests,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      fetchScheduleTests: courseManagementActions.fetchScheduleTests,
      getActiveGoals: getActiveGoals,
      showMsg,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(AddSyllabus));
